import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default  {
  namespaced: true,
  state: {
      items:[],
      partnerBranches:[],
      partnerStaff:[],
      accessLevels:[],
      partnerStocks:[],
      partnerActivations:[],
      partnerGrid:[],

  },
  actions,
  mutations,
  getters
}
